import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {AuthService} from '../services/auth.service';
import {Authority} from '../models/authority';
import {combineLatest, Subscription} from 'rxjs';
import {GraphService} from '../services/graph.service';

@Directive({
    selector: '[appHasRoleAndKvwNumber]',
    standalone: false
})
export class HasRoleAndKvwNumberDirective implements OnInit, OnDestroy {
    private authService = inject<AuthService>('AuthService' as any);
    private graphService = inject<GraphService>('GraphService' as any);
    private templateRef = inject<TemplateRef<any>>(TemplateRef);
    private viewContainer = inject(ViewContainerRef);

    @Input() public appHasRoleAndKvwNumber: { roles: Authority[]; kvwNumber: string | null; } | undefined;

    subscription = new Subscription();

    viewCreated = false;

    ngOnInit(): void {
        this.subscription.add(
            combineLatest([
                this.graphService.getCompany(),
                this.authService.authorities$
            ]).subscribe(([companyResponse, authorities]) => {
                if (authorities.includes(Authority.admin) // Admins can edit anything
                    || (companyResponse.kvwNumber === this.appHasRoleAndKvwNumber?.kvwNumber //  kvwNumber matches and has specified role
                    && authorities.some(authority => this.appHasRoleAndKvwNumber?.roles.includes(authority)))) {
                    if (!this.viewCreated) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                        this.viewCreated = true;
                    }
                } else {
                    this.viewContainer.clear()
                    this.viewCreated = false
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
